import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { removeModal } from 'actions/response';
import Button from 'react-bootstrap/lib/Button';

class ModalSuccessSentSMS extends Component {
  closeModal = () => {
    this.props.closeModal('SuccessSentSMS');
  };

  render() {
    const { message } = this.props;
    return (
      <Modal size="sm" show onHide={this.closeModal}>
        <Modal.Header>
          <Button
            className="close close-modal"
            onClick={() => this.closeModal()}
          >
            x
          </Button>
          <div className="text-center">
            <i className="fa fa-check-circle fa-3x" />
          </div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div>{message}</div>
        </Modal.Body>
      </Modal>
    );
  }
}
ModalSuccessSentSMS.propTypes = {
  message: PropTypes.string,
  closeModal: PropTypes.func,
};

const mapStateToProps = state => {};

const mapDispatchToProps = dispatch => ({
  closeModal: modalType => dispatch(removeModal(modalType)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalSuccessSentSMS);
